import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";

export const NewPill = styled(Box)`
  background: ${({ theme }) => theme.colors.envy};
  border-radius: 12px;
  color: white;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  text-transform: uppercase;
`;

// The red "New" tag used to flag newly shipped features.
export const NewBadge = styled(NewPill)`
  background: ${({ theme }) => theme.colors.alert};
  flex-shrink: 0;
`;

export const WarningIcon = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.caution};
`;
